import React from 'react';
import BottomNav from '../components/BottomNav';

const Advisory = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Advisory Services</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Expert Guidance & Consultation</p>
        
        <div className="card">
          <p>
            Access expert advisory services across wealth management, business strategy, 
            and personal development. Our advisors provide tailored guidance for your success.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Financial Advisory</h3>
              <p>Strategic wealth planning and investment advice</p>
            </div>
            <div className="feature-item">
              <h3>Business Consulting</h3>
              <p>Growth strategies and operational excellence</p>
            </div>
            <div className="feature-item">
              <h3>Legal & Tax</h3>
              <p>Expert counsel on complex legal and tax matters</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default Advisory;
